    <script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/holdings`;

const getHeaders = () => ({
  'Authorization': `Bearer ${utilsService.getToken()}`,
  'Content-Type': 'application/json',
});

function buildPayload(formRaw) {
  return {
    nombre: formRaw.nombre,
    activo: (typeof formRaw.activo === 'boolean') ? formRaw.activo : true,
  };
}

const holdingService = {
  async getActivos() {
    try {
      const { data } = await axios.get(`${apiUrl}/activos`, { headers: getHeaders() });
      return Array.isArray(data) ? data : [];
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getAll() {
    try {
      const { data } = await axios.get(apiUrl, { headers: getHeaders() });
      return Array.isArray(data) ? data : [];
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, { headers: getHeaders() });
      return response.data;
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async create(formRaw) {
    try {
      const response = await axios.post(apiUrl, buildPayload(formRaw), { headers: getHeaders() });
      return response;
    } catch (error) {
      // Si viene de Axios, re-lanzar tal cual para conservar response.status y response.data
      if (error && error.response) {
        throw error;
      }
      throw {
        response: {
          status: 0,
          data: (error && error.message) ? error.message : 'Error en la solicitud.',
        },
      };
    }
  },

  async update(formRaw, id) {
    try {
      const response = await axios.put(`${apiUrl}/${id}`, buildPayload(formRaw), { headers: getHeaders() });
      return response.status;
    } catch (error) {
      const data = (error && error.response) ? error.response.data : null;
      const msg = (data && data.message) ? data.message : (data || (error && error.message));
      throw new Error(msg || 'Error al actualizar el holding.');
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, { headers: getHeaders() });
      return response.status;
    } catch (error) {
      const data = (error && error.response) ? error.response.data : null;
      const msg = (data && data.message) ? data.message : (data || (error && error.message));
      throw new Error(msg || 'Error al eliminar el holding.');
    }
  },
};

export default holdingService;
</script>